import { useEffect } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import Swal from "sweetalert2";

import useField from "../../../customHooks/useField";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

import Skeletontable from "../employee/skeletonTable";

import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";
import { getSkills } from "../../../store/roles_skills";
import OneSkill from "./oneSkill";
import { BsSearch } from "react-icons/bs";
import NewSkill from "./new/newSkill";
import { useNavigate } from "react-router-dom";
import Footertable from "../../../components/pagination/footerPagination";

const Skills = () => {
  const { isShown: isModalShown, toggle: ToggleModal } = useModal();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const { status, skills, prev_page_url, current_page, next_page_url } =
    useAppSelector((state) => state.roles_skills);
  const { skills: userSkills } = useAppSelector((state) => state.user);

  const search = useField({
    type: "text",
    name: "search",
    placeholder: "Search Role by Name or Slug",
  });

  const searchAction = () => {
    dispatch(getSkills({ page: 1, search: search.value }));
  };

  const onSearchKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      dispatch(getSkills({ page: 1, search: search.value }));
    }
  };

  useEffect(() => {
    dispatch(getSkills({ page: 1 }));
  }, [dispatch]);
  useEffect(() => {
    if (
      !userSkills.includes("super.admin") &&
      !userSkills.includes("public.users.skills.manage")
    ) {
      navigate("/");
    }
  }, [userSkills]);

  useEffect(() => {
    if (status === "updateSkills_success") {
      dispatch(getSkills({ page: 1, search: search.value }));
      Swal.fire({ title: "Skill Updated", icon: "success" });
    } else if (status === "createSkill_success") {
      dispatch(getSkills({ page: 1, search: search.value }));
      Swal.fire({ title: "Skill Created", icon: "success" });
    } else if (status === "deleteSkill_success") {
      dispatch(getSkills({ page: 1, search: search.value }));
      Swal.fire({ title: "Skill Deleted", icon: "success" });
    }
  }, [status]);

  return (
    <>
      <Modal isActive={isModalShown} clouse={ToggleModal} title="New Skill">
        <NewSkill toggle={ToggleModal} isShown={isModalShown} />
      </Modal>
      <div className="c-table">
        <div className="c-table__header">
          <div className="c-table__box-options">
            <label className="c-table__search">
              <BsSearch />
              <input {...search} onKeyDown={(e) => onSearchKey(e)} />
            </label>
            <button
              className="c-table__button-secondary"
              onClick={searchAction}
            >
              Search
            </button>
          </div>
          <div className="c-table__box-options">
            <button
              type="button"
              className="c-table__button-secondary"
              onClick={ToggleModal}
            >
              <IoIosAddCircleOutline />
              New Skill
            </button>
          </div>
        </div>

        <table className="c-table__content">
          <thead>
            <tr>
              <td className="c-table__trheead">ID</td>
              <td className="c-table__trheead">Name</td>
              <td className="c-table__trheead">Slug</td>

              <td className="c-table__trheead">Actions</td>
            </tr>
          </thead>
          <tbody>
            {status === "getSkills_pending" && (
              <>
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
              </>
            )}
            {status !== "getSkills_pending" &&
              skills.map((skill) => (
                <OneSkill key={skill.id_encrypted} skill={skill} />
              ))}
          </tbody>
        </table>
        <Footertable
          prev_page_url={prev_page_url}
          current_page={current_page}
          next_page_url={next_page_url}
          method={getSkills}
          status={status}
          search={search.value}
        />
      </div>
    </>
  );
};

export default Skills;
